import React from 'react';
import styled from 'styled-components';

const StyledIconButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    min-width: 40px;
    background: ${({ background }) => background ? background : "transparent" };
    border: none;
    border-radius: 8px;
    color: ${({ color }) => color ? color : '#FFFFFF'};
    cursor: pointer;

    &:hover {
        color: ${({ hoverColor }) => hoverColor};
        background: ${({ hoverBackground }) => hoverBackground};
    }

    &[disabled] {
        background: var(--sp-disabled-color);
        color: var(--sp-disabled-text-color);
        cursor: not-allowed;
    }
`;

const StyledIcon = styled.i.attrs(({ariaLabel}) => ({
    'aria-label': `icon: ${ariaLabel}`
}))`
    display: flex;
    align-items: center;
    color: ${({disabled, color}) => disabled ? "rgba(0, 0, 0, 0.25)" : color ? color : ""};
    cursor: ${({disabled, cursor}) => disabled ? "not-allowed" : cursor};
    transform: ${({rotate}) => rotate && `rotateY(${rotate}deg)`};
    transition: ${({rotate}) => rotate && "transform 1s"};
    animation: ${({spin}) => spin && "spin-animation"} 1s linear infinite;

    &:hover {
        color: ${({ disabled, hoverColor }) => disabled ? "rgba(0, 0, 0, 0.25)" : hoverColor};
    }

    &:active {
        transform: ${({active}) => active && "translateY(1px)"};
    }


    @keyframes spin-animation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

const IconContainer = (props) => {
    let active = false;
    if (typeof props.onClick === "function") {
        active = true;
    }
    return (
        <StyledIcon active={active} cursor={active ? "pointer" : props.cursor} {...props}>
            {props.children}
        </StyledIcon>
    )
};

const IconButton = (props) => {
    return (
        <StyledIconButton {...props}>
            {props.children}
        </StyledIconButton>
    )
};

export { IconContainer };
export { IconButton };